import { useTranslation } from "@redotech/redo-i18n";
import { Text } from "@redotech/redo-web/text";
import { Component, memo, type ErrorInfo, type ReactNode } from "react";
import * as returnFlowCss from "../return-flow/return-flow.module.css";

const InspectorErrorMessage = memo(function InspectorErrorMessage() {
  const { t } = useTranslation();

  return (
    <>
      <Text>{t("An error occurred while displaying this step.")}</Text>
      <Text>{t("Try selecting a different step or refreshing the page.")}</Text>
    </>
  );
});

export class InspectorErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Flow inspector render error:", error, errorInfo);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className={returnFlowCss.detailsContent}>
          <InspectorErrorMessage />
        </div>
      );
    }
    return this.props.children;
  }
}
